import DarkMode from './DarkMode';

export default DarkMode;
